import initialState from './initialState';
import {SET_UUID} from '../actions/actionTypes';

export default function uuid(state = initialState.uuid, action) {
  switch (action.type) {
    case SET_UUID:
      return action.uuid;
    default:
      return state;
  }
}
